/* eslint-disable prefer-object-has-own */
import { useMemo, useState, useRef } from 'react'
import { message as $message } from 'antd'
import { useMemoizedFn } from 'ahooks'
import ReactDOM from 'react-dom'
import { getOrderAmount } from '@/services/afterSale'
import {
    waitInterceptionCountApi,
    logisticsInterceptionStatisticsApi,
    alreadyInterceptionOrderCountApi,
} from '@/services/expressInterception'
import { APPLIED_INTERCEPTED, TOBE_INTERCEPTED, INTERCEPTED_SUCCESS } from '@/modules/order/constants'
import { getInitialValues } from '@/pages/TowerQianKun/ExpressInterception/helper'
import { splitRequest } from '@/utils/utils'
import { OrderTypeEnum } from '@/modules/afterSale/components/AfterSaleOrderTypeRadio'

const defaultOverdueQuery = {
    [TOBE_INTERCEPTED]: {
        checked: true,
    },
    [APPLIED_INTERCEPTED]: {
        checked: false,
    },
    [INTERCEPTED_SUCCESS]: {
        checked: false,
    },
}
// 1001-待拦截统计,1002-已发起拦截统计,1003-标记拦截成功统计
const MAP_COUNT = {
    1001: TOBE_INTERCEPTED,
    1002: APPLIED_INTERCEPTED,
    1003: INTERCEPTED_SUCCESS,
}

export default function useExpressInterception() {
    const [selected, setSelected] = useState([])
    const [selectedRows, setSelectedRows] = useState([])
    const [overdueQuery, setOverDueQuery] = useState(defaultOverdueQuery)
    const [query, setQuery] = useState(getInitialValues(defaultOverdueQuery))
    const [queryValues, setQueryValues] = useState({})
    const [listFetchData, setListFetchData] = useState<any>({})
    const [amountLoading, setAmountLoading] = useState(false)
    const [amountList, setAmountList] = useState([])
    const [waitInterceptionCount, setWaitInterceptionCount] = useState(0)
    const [alreadyInterceptionCount, setAlreadyInterceptionCount] = useState(0)
    const [allCount, setAllCount] = useState({})
    const activeType = useMemo(() => {
        return Object.keys(overdueQuery)?.find(item => overdueQuery[item]?.checked) || TOBE_INTERCEPTED
    }, [overdueQuery])

    const fetchRef = useRef(0)
    const fetchRef1 = useRef(0)

    const onSetQueryByPageUrl = useMemoizedFn(pageQuery => {
        const { tab, ...restPageQuery } = pageQuery || {}
        const overdueValues = Object.keys(overdueQuery)?.reduce((prev, cur) => {
            return {
                ...prev,
                [cur]: {
                    checked: tab === cur,
                },
            }
        }, {})
        const initValue = getInitialValues(overdueValues, restPageQuery)
        setOverDueQuery(overdueValues)
        setQueryValues(initValue)
        setQuery(initValue)
    })

    const reload = () => {
        listFetchData?.reload?.()
    }

    const refresh = () => {
        listFetchData?.refresh?.()
        getAllCount(OrderTypeEnum.ALL)
    }
    const clearSelected = () => {
        setSelected([])
        setSelectedRows([])
    }
    const onToSee = val => {
        const { overdueKey, ...rest } = val || {}
        if (val) {
            ReactDOM.unstable_batchedUpdates(() => {
                if (overdueKey) {
                    setOverDueQuery(pre => {
                        for (let key in pre) {
                            if (Object.prototype.hasOwnProperty.call(pre, key)) {
                                pre[key].checked = false
                            }
                        }
                        return {
                            ...pre,
                            [overdueKey]: {
                                ...pre[overdueKey],
                                checked: true,
                            },
                        }
                    })
                }
                setQuery(rest)
                setQueryValues(rest)
            })
        }
    }
    const getAmountList = async (oidList: any) => {
        setAmountLoading(true)
        // 去重复
        const newoidList = [...new Set(oidList)]
        const { success, message, data } = await splitRequest({ promise: getOrderAmount, paramArr: newoidList })
        if (success) {
            const amountArr = data?.reduce((prev, cur) => {
                return [...prev, ...cur.amountInfoList]
            }, [])
            setAmountList(amountArr || [])
        } else {
            $message.error(message)
        }
        setAmountLoading(false)
    }
    // 物流待拦截列表count
    const getWaitInterceptionCount = async params => {
        fetchRef1.current += 1
        const fetchId1 = fetchRef1.current
        const { success, message, data } = await waitInterceptionCountApi(params)

        if (fetchId1 !== fetchRef1.current) {
            return
        }

        if (success) {
            setWaitInterceptionCount(data)
        } else {
            $message.error(message)
        }
    }
    // 物流已拦截列表count
    const getAlreadyInterceptionCount = async params => {
        fetchRef.current += 1
        const fetchId = fetchRef.current

        const { success, message, data } = await alreadyInterceptionOrderCountApi(params)

        if (fetchId !== fetchRef.current) {
            return
        }

        if (success) {
            setAlreadyInterceptionCount(data)
        } else {
            $message.error(message)
        }
    }
    // 查询数字统计
    const getAllCount = async orderTypeEnum => {
        const { success, message, data } = await logisticsInterceptionStatisticsApi({
            interceptStatus: -1,
            orderTypeEnum: orderTypeEnum || OrderTypeEnum.ALL,
        })
        if (success) {
            if (data?.length) {
                const allcount = data.reduce((res, item) => {
                    res[MAP_COUNT[item.interceptStatus]] = item.count
                    return res
                }, {})

                setAllCount(pre => {
                    return {
                        ...pre,
                        [orderTypeEnum || OrderTypeEnum.ALL]: allcount,
                    }
                })
            }
        } else {
            $message.error(message)
        }
    }

    return {
        reload,
        refresh,
        selected,
        setSelected,
        selectedRows,
        setSelectedRows,
        clearSelected,
        listFetchData,
        setListFetchData,
        onToSee,
        overdueQuery,
        setOverDueQuery,
        queryValues,
        query,
        setQuery,
        setQueryValues,
        getAmountList,
        amountLoading,
        amountList,
        getWaitInterceptionCount,
        getAlreadyInterceptionCount,
        waitInterceptionCount,
        alreadyInterceptionCount,
        activeType,
        allCount,
        getAllCount,
        onSetQueryByPageUrl,
    }
}
